
export class TruePlanVars {
    static varServiceURL = process.env.REACT_APP_API_URL; // Define as a static property
    static varSocketURL = process.env.REACT_APP_SOCKET_URL; // Define as a static property
}
